// extracted by mini-css-extract-plugin
export var hidden = "_sj-0";